'use client'
import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useDispatch, useSelector } from 'react-redux'
import { addTemplateId } from './../redux/reducers/invoiceSlice'

export default function TemplateCardHydration({ intentKey }) {
  const router = useRouter()
  const dispatch = useDispatch()
  const invoice = useSelector(state => state.invoice)

  useEffect(() => {
    const cards = document.querySelectorAll('[data-template-id]')
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const id = card.getAttribute('data-template-id')
        dispatch(addTemplateId(id))

        if (!invoice.isFormfilled) {
          router.push(`/invoice/create/create-${intentKey}`)
          return
        } 
        router.push(`/invoice/download/download-${intentKey}`)
      })
    })
  }, [])

  return null
}
